<button 
    class="btn-audio" 
    (click)="skipBackwards()"
    [style.background-color]="disabled ? 'grey' : ''"
    >
    <fa-icon [icon]="faUndoAlt"></fa-icon>
</button>